/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-tag/webhook-form-tag.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
/*# sourceMappingURL=webhook-form-tag.component.css.map */
